var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function formHookExtensions(formHook) {
    return {
        registerMaskedTextField: function (field) {
            var value = formHook.getFieldValue(field);
            return {
                value: typeof value === 'string' ? value : '',
                onBlur: function () { return formHook.setFieldTouched(field, true); },
                onChange: function (value) {
                    formHook.setFieldValue(field, value);
                },
                errorText: formHook.getErrorText(field)
            };
        },
        registerInputWithErrorText: function (field) {
            return __assign(__assign({}, formHook.registerInput(field)), { errorText: formHook.getErrorText(field), touched: formHook.getTouched(field) });
        },
        registerRadioGroup: function (field) {
            return {
                value: formHook.getFieldValue(field),
                onChange: function (event, checked) {
                    formHook.setFieldValue(field, checked);
                    formHook.setFieldTouched(field, true);
                },
                errorText: formHook.getErrorText(field),
                touched: formHook.getTouched(field)
            };
        },
        registerSwitch: function (field) { return ({
            onBlur: function () { return formHook.setFieldTouched(field, true); },
            onChange: function (event, value) {
                formHook.setFieldValue(field, value);
            },
            checked: !!formHook.getFieldValue(field)
        }); },
        registerStyledSelect: function (field, options) {
            var hasEmptyValue = !!options && 'emptyValue' in options;
            return {
                value: formHook.getFieldValue(field),
                onClear: function () {
                    if (!hasEmptyValue) {
                        return;
                    }
                    formHook.setFieldValue(field, options.emptyValue);
                    formHook.setFieldTouched(field, true);
                },
                onSelection: function (item) {
                    formHook.setFieldValue(field, item);
                    formHook.setFieldTouched(field, true);
                },
                errorText: formHook.getErrorText(field),
                isClearable: hasEmptyValue
            };
        }
    };
}
